module.exports = __webpack_public_path__ + "img/eg-5.2988d187.png";